module.exports = __webpack_public_path__ + "img/cream-reuzel-blue-340.0939b734.jpg";